import { inject } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const canUseNewOidcLoginObservableCallback = (): Observable<boolean> => {
  return inject(SettingsService).getNewAuthEnabled();
};

export const canUseDeprecatedHybridLoginGuard: CanMatchFn = (): Observable<boolean> =>
  canUseNewOidcLoginObservableCallback()
    .pipe(
      map(useNew => !useNew),
    );

export const newOidcLoginFeatureGuard: CanActivateFn = (): Observable<boolean> =>
  canUseNewOidcLoginObservableCallback();

